module.exports = __webpack_public_path__ + "img/423.c0b873b6.jpg";